import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import ButtonPrimary from 'components/ButtonPrimary/index.js'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import logEventAnalyticsUtil from 'modules/analytics/utils/log-event/index.js'
import { GetAppButton } from 'components/DownloadButton/index.js'
import TextBodySmaller from 'components/TextBodySmaller.js'
import { isLoggedInTrainingUserSelect } from 'modules/training/modules/training-users/selectors/is-logged-in'

const messages = defineMessages({
  trusted: {
    id: 'CheckExerciseFormCTA.trusted',
    defaultMessage: '⭐ Trusted by 80,000+ fitness lovers worldwide.'
  },
  getStarted: {
    id: 'CheckExerciseFormCTA.getStarted',
    defaultMessage: 'Get started'
  },
  preferToStartInTheApp: {
    id: 'CheckExerciseFormCTA.preferToStartInTheApp',
    defaultMessage: 'Prefer to start in the app?'
  }
})

const ANALYTIC_EVENT = {
  CHECK_EXERCISE_FORM_GET_STARTED: 'CHECK_EXERCISE_FORM_GET_STARTED'
}

export const CheckExerciseFormCTA = ({ isCentered }) => {
  const intl = useIntl()
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const isLoggedIn = useSelector(isLoggedInTrainingUserSelect)

  const handleClick = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.CHECK_EXERCISE_FORM_GET_STARTED)
  }

  return (
    <View mt={2}>
      <TextBodySmaller
        c='paragraph'
      >
        {formatMessageIntlUtil(intl, messages.trusted)}
      </TextBodySmaller>

      <View mt>
        <ButtonPrimary
          url={ROUTE_PATH.TOOLS_CHECK_EXERCISE_FORM}
          onClick={handleClick}
          style={{
            margin: isSmallScreen || isCentered ? '0 auto' : 'unset'
          }}
        >
          {formatMessageIntlUtil(intl, messages.getStarted)}
        </ButtonPrimary>
      </View>

      {isLoggedIn && (
        <View mt={4}>
          <TextBodySmaller>
            {formatMessageIntlUtil(intl, messages.preferToStartInTheApp)}
          </TextBodySmaller>
          <GetAppButton
            appStoreHeight='2.4em'
            playStoreHeight='2.56em'
            style={{
              justifyContent: isCentered || isSmallScreen ? 'center' : 'flex-start'
            }}
          />
        </View>
      )}
    </View>
  )
}
